import Vue from 'vue'
import windowResizeMixin from './window-resize'
import permissonMixin from './permission'
import sendLogMixin from './send-log'
import { accountUrl } from '@/assets/js/config'
import { getCookie, setCookie, delCookie, deleteAllCookie } from '@/assets/utils/CommonUtil'
import {isIE, isSameUser, getParams, processParams} from '@/assets/utils'
import service from '@/assets/service'
import MessageService from '@/assets/service/message'
import commonService from '@/assets/service/common'
import HomeService from '@/assets/service/home'
import LoginService from '@/assets/service/login'
import Bus from '@/assets/utils/bus'
import store from '@/store'
import {mapState, mapMutations, mapActions} from 'vuex'
import userService from '@/assets/service/user'
Vue.mixin({
  data () {
    return {
      nowYear: new Date().getFullYear(),
      tableHeight: 0,
      user: {},
      timer: {
        Message: null,
        Feedback: null,
        Upload: null
      },
      refreshHeaderIndex: 0, // 通过这个可以强制刷新头部显示信息 为最新
      sessionTimer: null,
      backToTopCustomStyle: {
        right: '25px',
        bottom: '50px',
        width: '40px',
        height: '40px',
        'border-radius': '4px',
        'line-height': '40px',
        background: '#fff',
        boxShadow: '0px 2px 16px 0px rgba(33, 37, 48, 0.2'
      },
      bimFaceError: require('//static/images/bimface/error.png'),
      colorMap: {
        'r2-icon-cailiao': 'orange',
        'r2-icon-zhibiao': 'blue',
        'r2-icon-jijia': 'green',
        'r2-icon-jisuan': 'cyan',
        'r2-icon-guize': 'blue'

      }
    }
  },
  directives: {
    debounce: {// 防抖函数指令
      inserted: function (el, binding) {
        let timer
        el.addEventListener('click', () => {
          if (timer) {
            clearTimeout(timer)
          }
          timer = setTimeout(() => {
          // 关键点:vue 的自定义指令传递的参数binding 如果是一个函数,则通过      binding.value()来执行,通过上述示例,还可以传递比如事件, 绑定对象之类的
            binding.value()
          }, 1000)
        })
      }
    }
  },
  mixins: [windowResizeMixin, sendLogMixin, permissonMixin],
  computed: {
    ...mapState({
      applicationPermission: state => state.menus.applicationPermission,
      loadingInStore: state => state.config.loading, // 存在store里的loading
      userInStore: state => state.user.user,
      grayDomain: state => state.user.user.grayDomain,
      hasUploadTask: state => state.upload.hasUploadTask,
      uploadhistory: state => state.sidebarData.uploadhistory,
      noUsablePackageAlertShow: state => state.config.noUsablePackageAlertShow,
      sessionAlertShow: state => state.config.sessionAlertShow
    }),
    // 判断项目地址，用于隐藏右上角个人信息与登出跳转地址
    isCostCloud1 () {
      return !(this.grayDomain || '').includes('cfmcc')
    },
    // 判断项目地址，用于隐藏右上角个人信息与登出跳转地址
    isCostCloud () {
      return !(this.user.grayDomain || '').includes('cfmcc')
    },
    role () {
      return +getCookie('role')
    },
    roleName () {
      let str = ''
      // switch (this.role) {
      //   case 1:
      //     str = '管理员'
      //     break
      //   case 2:
      //     str = '总负责人'
      //     break
      //   case 3:
      //     str = '档案室负责人'
      //     break
      //   case 4:
      //     str = '普通员工'
      //     break
      //   case 5:
      //     str = '个人账号'
      //     break
      //   default:
      // }
      return str
    },
    // 页面类型
    pageType () {
      const path = this.$route.path
      let type = ''
      if (/^\/preview(\/)?/.test(path)) {
        // 预览文件 页面
        type = 'preview'
      } else if (/^\/database\/basis/.test(path)) {
        // 企业造价数据
        type = 'databaseBasis'
      } else if (/^\/enterprise\/share/.test(path)) {
        // 企业共享空间
        type = 'enterpriseShare'
      }
      return type
    },
    isPreviewPage () {
      return this.pageType === 'preview'
    },
    hrefPrefix () {
      let href = window.location.href
      return href.substring(0, href.indexOf('/#'))
    }
  },
  beforeRouteEnter (to, from, next) {
    const userInfoInCookie = getCookie('ZJYUSERINFO')
    const userInfoInWindow = window.ZJYUSERINFO
    if (userInfoInCookie && !userInfoInWindow) {
      window.ZJYUSERINFO = userInfoInCookie
    }
    store.dispatch('menus/setLeftMenus', to) // 设置目标页面的左侧菜单数据
    next()
  },
  beforeRouteLeave (to, from, next) {
    if (!isSameUser() && to.path !== '/download' && to.path !== '/vip') {
      // 套餐详情页、下载页 不登录也能访问
      this.setConfigState({sessionAlertShow: true})
    }
    next()
  },
  mounted () {
    // 接收zjy-ui中dialog的显示状态，并传递到父级窗口
    this.$on('toggleDialogVisible', (status = false) => {
      this.parentPostMessage({
        type: 1,
        data: {
          status
        }
      })
    })
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    this.loadImg(this.bimFaceError)
  },
  methods: {
    ...mapMutations({
      setSubscribeMaskStatus: 'SET_MASK_STATUS',
      setLoading: 'config/SET_LOADING',
      setConfigState: 'config/SET_CONFIG_STATE',
      setUserInfo: 'user/SET_USERINFO',
      setUploadData: 'sidebarData/SET_UPLOAD_DATA',
      setUploadMessage: 'upload/SET_UPLOAD_MESSAGE',
      setUploadTaskStatus: 'upload/SET_UPLOAD_TASK_STATUS' // 设置是否有上传任务正在执行
    }),
    ...mapActions({
      setLeftMenus: 'menus/setLeftMenus'
    }),
    // 10.1 初始化 iframe 子窗口 通过postMessage 派发给父窗口事件（接收消息）
    handMessage (event) {
      event = event || window.event
      // 验证是否来自预期内的域，如果不是不做处理，这样也是为了安全方面考虑
      // if (event.origin === 'https://www.zjytest.glodon.com') {
      //   this.message = event.data + Date.now()
      //   console.log(event.data)
      // }
      let {model = 0, data = {}, frameLoginSuccess, product = ''} = event.data || {}
      let {emitName = '', mask = false, uploadParams = {}, callbackParams = {}} = data
      // iframe登录成功回调
      if (typeof frameLoginSuccess === 'boolean') {
        switch (product) {
          case 'qydata':
            Bus.$emit('qyDataLogin', frameLoginSuccess)
            break
          default:
        }
      }
      if (event.data === 'geip-logout') {
        this.accountLogout()
      }else if(typeof (event.data) === 'string'){
        data = JSON.parse(event.data)
      }
      // 项管消息嵌入跳转
      if (data.type === 'messageJump'){
        if (data.type === 'messageJump'){
          const arr = data.url.split('?')[1].split('&')
          let menuCode = ''

          arr.forEach(ele => {
            if (ele.includes('menuCode')){
              menuCode = ele.split('=')[1]
            }
          })
          console.log(menuCode)
          this.$router.push({
            path: '/iframePortal',
            query: { menuCode }
          })
        }
      }
      
      // 用户中心
      if(data.type === 'user-center-extend'){
        // console.log('********发消息了*************',data.menuCode)
        const urlDomain = window.location.origin
        const basePortalUrl = `${urlDomain}/#/iframePortal?menuCode=${data.entryCode}&viewMode=application&orgId=${getCookie('orgId')}&applicationCode=pmpp.member&productCode=pmpp`
        window.open(basePortalUrl,'_blank')
      }
      if (event.data.gldUserId){
        const gldUserId = getCookie('gldUserId')
        if (gldUserId && gldUserId !== event.data.gldUserId) {
          console.log('子页面的postMessage消息-----------', event.data)
        }
      }
      /**
      ** 订阅类型
      * model类型 [1. 遮罩层 2. 上传 3. 退出登录 4. session超时 5. 没有购买套餐提示]
      */
      switch (+model) {
        // 控制遮罩层
        case 1:
          // console.log('0000000000')
          // console.log(mask)
          this.setSubscribeMaskStatus(mask)
          break
        // 触发 上传
        case 2:
          // 获取当前页面
          let nowPage = ''
          const path = this.$route.path
          if (/^\/space\/files\/list/.test(path)) {
            // 个人空间
            nowPage = 'personage'
          } else if (/^\/project\/(all|joined)/.test(path)) {
            // 项目库
            nowPage = 'enterprise'
          } else if (/^\/enterprise\/share/.test(path)) {
            // 共享空间
            nowPage = 'share'
          } else {
            // 员工数据库、个人数据库
            let reg = /^\/space\/database\/([^/?&]+)(\/|$|\?)/
            if (/^\/database/.test(path)) {
              // 电子档案室
              reg = /^\/database\/basis\/([^/?&]+)(\/|$|\?)/
            }
            const matchArr = reg.exec(path)
            if (matchArr && matchArr.length > 1) {
              nowPage = matchArr[1]
            }
            // iframe 员工数据-清单-组件   电子档案室-清单-组件
            if (/^\/iframe/.test(path)) {
              nowPage = decodeURIComponent(path).match(/.*\/(.*)\/.*$/)[1]
            }
          }
          if (emitName === 'openUploader') {
            const params = {
              nowPage,
              showConfirm: false,
              isDataModule: true,
              moduleName: '数据文件',
              uploadResultAction: 'data_manage/upload_result'
            }
            // 清单、组价页面上传本地文件验证文件后缀格式
            if (['inventory', 'combination'].includes(nowPage) && [2, 5].includes(uploadParams.parameter.uploadType)) {
              // 上传本地清单文件
              if (nowPage === 'inventory') {
                params.showConfirm = true
              }
              params.suffix = 'GBQ5,GPB5,GPV5,GSC5,GSH5,GBQ6,GPB6,GPV6,GSC6,GSH6,,GBQ7,GPB7,GPV7,GSC7,GSH7'
              params.suffixAlertMessage = '不支持此类工程文件导入，支持的范围为：08，13清单，后缀名为GBQ5，GPB5，GPV5，GSC5，GSH5，GBQ6，GPB6，GPV6，GSC6，GSH6的工程'
            }
            if (uploadParams.parameter.accept && [3, 6].includes(uploadParams.parameter.uploadType)) {
              params.suffix = uploadParams.parameter.accept
              params.suffixAlertMessage = '不支持此类工程文件导入'
            }
            Object.assign(uploadParams, params)
            // 上传本地文件、上传清单数据、上传组价数据
            Bus.$emit(emitName, uploadParams, Object.assign(callbackParams, {fnName: 'postMessage'}))
          } else if (emitName === 'beforeUploadCloudFile') {
            Object.assign(uploadParams[1], {
              nowPage,
              showConfirm: false,
              isDataModule: true,
              moduleName: '数据文件',
              uploadResultAction: 'data_manage/upload_result',
              uploadAction: 'data_manage/bill_quantity/upload_cloud_file'
            })
            if (nowPage === 'inventory') {
              uploadParams[1].showConfirm = true
              // uploadParams[1].uploadAction = 'data_manage/bill_quantity/upload_cloud_file'
            }
            // 上传云文件
            Bus.$emit(emitName, ...uploadParams, Object.assign(callbackParams, {fnName: 'postMessage'}))
          }
          break
        // 退出登录
        case 3:
          this.accountLogout()
          break
        //  session 超时 弹出session 超时框
        case 4:
          if (!this.sessionAlertShow) {
            // this.setUserInfo({})
            delCookie('ZJYUSERINFO')
            this.setConfigState({ sessionAlertShow: true })
          }
          break
        //  没有购买套餐 提示
        case 5:
          if (!this.noUsablePackageAlertShow) {
            this.setConfigState({ noUsablePackageAlertShow: true })
          }
          break
        default:
      }
    },
    // 10.2  父级窗口 通过postMessage 向嵌入的iframe 派发事件 data为传递内容，*修改为具体域名或者ip
    postMessage (data) {
      // postMessage第一个参数为发送的内容
      // 第二个参数为要要传送的目的地，当然如果不限于任何域名的话可以填*字符，以表示全部
      try {
        let iframeWindow = document.getElementById('innerIframe').contentWindow
        iframeWindow.postMessage(data, '*')
      } catch (e) {
        console.log(e)
      }
    },
    // 与父级窗口通信
    logicDistributeWithFrames (runningFrames, runningOriginal) {
      // const { from } = this.$route.query
      // if (window.parent[0] && window.parent[0].name === 'dcost-web' && from === 'dcost') {
      //   (typeof runningFrames === 'function') && runningFrames()
      // } else {
      //   (typeof runningOriginal === 'function') && runningOriginal()
      // }
      if (self !== top) {
        (typeof runningFrames === 'function') && runningFrames()
      } else {
        (typeof runningOriginal === 'function') && runningOriginal()
      }
    },
    // 设置frame父级内容区域外遮罩的显示与隐藏
    setFramesMask (status) {
      this.logicDistributeWithFrames(() => {
        this.parentPostMessage({
          type: 1,
          data: {
            status
          }
        })
      })
    },
    // 与父级窗口通信
    parentPostMessage (message) {
      window.parent.postMessage(message, '*')
    },
    // 1. 设置表格高度
    setTableHeight (otherHeight) {
      const height = otherHeight + 50 || 50 // 表格默认会占用比自己 多 49px 高度
      let windowHeight = document.documentElement.clientHeight
      this.tableHeight = windowHeight - height
    },
    // 2. 顶级菜单点击 切换模块儿 windowName 为配置系统子模块名称与权限的唯一标识
    switchModule (item, isModule, isUpdata) {
      const ZJYUSERINFO = getCookie('ZJYUSERINFO')
      const findRoute = (tempItem) => {
        switch (tempItem.path) {
          case '/manage': // 人员及资产管理
            this.sentLog(100117001)
            break
          case '/project': // 项目库
            this.sentLog(100110031)
            break
          case '/space': // 员工资料库、个人空间
            this.sentLog(100110032)
            break
          case '/enterprise': // 共享空间
            this.sentLog(100110033)
            break
          case '/database': // 电子档案室
            this.sentLog(100110034)
            break
          case '/workbench': // 工作台
            this.sentLog(100110037)
            break
          default:
        }
        if (tempItem.children && tempItem.children.length) {
          if (tempItem.path === '/enterprise' && tempItem.children.length > 1) {
            return findRoute(tempItem.children[1], tempItem.path)
          } else {
            return findRoute(tempItem.children[0], tempItem.path)
          }
        } else {
          const fnCodeMap = {
            '企业材料库': 100110038,
            '企业指标库': 100110039,
            '计价依据库': 100110040,
            '组价数据库': 100110041,
            '量价规则库': 100110042
          }
          const status = (tempItem.permissionId && !this.applicationPermission[tempItem.permissionId]) ? 0 : 1
          fnCodeMap[tempItem.menuName] && this.sentLog(fnCodeMap[tempItem.menuName], {status})
          if (+tempItem.viewType === 1) {
            return tempItem.path
          } else {
            if (!ZJYUSERINFO) {
              this.setConfigState({sessionAlertShow: true})
              return ''
            }
            tempItem.appId = tempItem.id
            this.openLinkNewTab(tempItem, (url) => {
              this.$router.push({
                path: `/iframe/${encodeURIComponent(url)}/${encodeURIComponent(tempItem.title)}?t=${new Date().getTime()}&linkUrl=${encodeURIComponent(tempItem.linkUrl)}`
              })
              // this.$router.push({
              //   path: `/iframe/${encodeURIComponent(url)}/${encodeURIComponent(tempItem.title)}/${tempItem.windowName}?t=${new Date().getTime()}&linkUrl=${encodeURIComponent(tempItem.linkUrl)}`
              // })
            })
            return ''
          }
        }
      }
      let path = item.path
      // 判断是不是子模块系统
      if (isModule) {
        // 判断子系统未购买--计价依据库
        const getWindowName = (element) => {
          if (element.windowName) {
            return {windowName: element.windowName, permission: element.modulePermission}
          }
          if (element.children && element.children.length) {
            return getWindowName(element.children[element.children.length - 1])
          } else {
            return ''
          }
        }
        let {windowName, permission} = getWindowName(item)
        if (windowName === 'target_jjyj_01' && typeof this.applicationPermission[item.permissionId] === 'boolean' && !this.applicationPermission[item.permissionId]) {
          this.sentLog(100110040, {status: 0})
          this.$router.push({
            path: '/board/no_permission',
            query: {title: item.menuName, content: item.remark, msg: '暂未购买当前产品，可联系您的广联达客户经理咨询购买', buy: true}
          })
        } else if (windowName === 'ROLE_QYDB_ESTI' || windowName === 'ROLE_QYDB_LJ') { // 判断组价和量价权限
          if (isUpdata) {
            if (permission || windowName === 'ROLE_QYDB_ESTI') {
              if (item.path === '/applications') {
                path = '/applications/home'
                this.sentLog(100110035)
                return
              } else {
                path = findRoute(item)
              }
              if (path) {
                this.$router.push({path})
              }
            } else {
              this.sentLog(windowName === 'ROLE_QYDB_ESTI' ? 100110041 : 100110042, {status: 0})
              this.$router.push({
                path: '/board/no_permission',
                query: {title: windowName === 'ROLE_QYDB_ESTI' ? '组价数据库' : '量价规则库', content: '无该数据库管理权限，请联系总负责人为您开通', msg: ''}
              })
            }
          } else {
            commonService.getUsePermissionApplications().then(data => {
              if (data.code === 200) {
                if (data.data.find((child) => child.code === windowName) || windowName === 'ROLE_QYDB_ESTI') {
                  if (item.path === '/applications') {
                    path = '/applications/home'
                    this.sentLog(100110035)
                    return
                  } else {
                    path = findRoute(item)
                  }
                  if (path) {
                    this.$router.push({path})
                  }
                } else {
                  this.sentLog(windowName === 'ROLE_QYDB_ESTI' ? 100110041 : 100110042, {status: 0})
                  this.$router.push({
                    path: '/board/no_permission',
                    query: {title: windowName === 'ROLE_QYDB_ESTI' ? '组价数据库' : '量价规则库', content: '无该数据库管理权限，请联系总负责人为您开通', msg: ''}
                  })
                }
              }
            })
          }
        } else {
          if (item.path === '/applications') {
            path = '/applications/home'
            this.sentLog(100110035)
            return
          } else {
            path = findRoute(item)
          }
          if (path) {
            this.$router.push({path})
          }
        }
      } else {
        if (item.path === '/applications') {
          path = '/applications/home'
          this.sentLog(100110035)
          return
        } else if (item.path === '/workbench'){
          path = '/workbench'
          this.sentLog(100110037)
        } else {
          path = findRoute(item)
        }
        if (path) {
          this.$router.push({path})
        }
      }
    },
    // 获取表格高度
    getTableHeight (el) {
      let dom = document.getElementById(el)
      return dom ? (dom.clientHeight || dom.scrollHeight) : 0
    },
    // 获取宽度
    getDomWidth (el) {
      let dom = document.getElementById(el)
      return dom ? (dom.clientWidth || dom.scrollWidth) : 0
    },
    // 2.2 所有的 操作记录 统一调这里
    // optType
    //   1: "下载",
    //   2: "删除",
    //   3: "彻底删除",
    //   4: "清空回收站",
    //   5: "还原",
    //   6: "重命名",
    //   7: "移动",
    //   8: "预览工程",
    //   9: "预览模型",
    //   10: "新建项目",
    //   11: "删除项目",
    //   12: "重命名项目",
    //   13: "添加成员",
    //   14: "删除成员",
    //   15: "修改项目编号",
    //   16: "修改项目类型",
    //   17: "修改项目进度",
    //   18: "修改项目概况"
    addOperationRecords (optType, value, obj, prjId) {
      const {page, action} = obj || {}
      let type = 0
      let apiName = ''
      let dataType = 0
      let workspaceId = getCookie('enterpriseWorkspaceIdValue')
      let projectId = prjId || this.$route.params.id
      const href = this.$route.path
      // 注释以下代码是因为代码已移交计价的服务处理
      // if (/database\/[^/]+/.test(href)) {
      //   // 只记录 总负责人和档案室负责人对数据的操作记录
      //   if (+this.userInStore.role !== 2 && +this.userInStore.role !== 3) return
      //   type = 1 // 数据
      //   apiName = 'addCompanyDataOpration'
      //   if (/database\/basis\/inventory/.test(href)) {
      //     dataType = 1
      //   }
      //   if (/database\/basis\/quota/.test(href)) {
      //     dataType = 2
      //   }
      //   if (/database\/basis\/material/.test(href)) {
      //     dataType = 3
      //   }
      //   if (/database\/basis\/combination/.test(href)) {
      //     dataType = 4
      //   }
      // } else
      if (/enterprise\/share/.test(href)) {
        type = 2 // 共享空间
        apiName = 'addCompanyOpration'
      } else if (/\/project\//.test(href)) {
        type = 3 // 项目库
        apiName = 'addCompanyProjectOpration'
      }
      if (page === 'recycle') {
        // 回收站 个人账号 不做操作记录---------目前个人账号已没有共享资料库菜单权限
        // if (+this.userInStore.userType === 2) return
        // 员工不是项目空间不记录
        if (+this.userInStore.role === 4 && !/\/project\//.test(href)) return
        if (!type) {
          type = 2 // 共享空间
          apiName = 'addCompanyOpration'
        }
      }
      if (!type) return
      let params = []
      if (type === 1) {
        // 数据相关 操作记录
        params.push({
          account: this.userInStore.userName,
          area: this.userInStore.area,
          dataType,
          optType: optType,
          num: value
        })
        projectId = ''
      } else {
        if (/\/project\/\w*\/list$/.test(href) || /\/project\/add$/.test(href)) {
          // 项目列表页、创建项目
          if (action === 'addMember') {
            // 项目添加员工
            value.forEach((nowItem) => {
              params.push({
                account: this.userInStore.userName,
                area: this.userInStore.area,
                optType,
                type: '',
                detail: nowItem.email
              })
            })
            workspaceId = ''
          } else {
            params.push({
              account: this.userInStore.userName,
              area: this.userInStore.area,
              optType: optType,
              type: '项目',
              detail: value
            })
            apiName = 'addCompanyOpration'
            projectId = ''
          }
        } else {
          switch (page) {
            case 'detailOutLine':
              workspaceId = ''
              value.forEach(item => {
                params.push({
                  account: this.userInStore.userName,
                  area: this.userInStore.area,
                  optType: item.type,
                  type: '',
                  detail: item.detail
                })
              })
              break
            case 'detailMember':
              workspaceId = ''
              switch (action) {
                case 'deleteMember': // 项目删除员工
                  params.push({
                    account: this.userInStore.userName,
                    area: this.userInStore.area,
                    optType,
                    type: '',
                    detail: value
                  })
                  break
                case 'addMember': // 项目添加员工
                  value.forEach((nowItem) => {
                    params.push({
                      account: this.userInStore.userName,
                      area: this.userInStore.area,
                      optType,
                      type: '',
                      detail: nowItem.email
                    })
                  })
                  break
                default:
              }
              break
            default:
              // 空间相关 操作记录
              const addRecords = (nowItem) => {
                let type = ''
                if (nowItem.folder) {
                  type = '文件夹'
                } else if (+nowItem.fileType === 1) {
                  type = '计价'
                } else if (+nowItem.fileType === 2) {
                  type = '计量'
                }
                let detail = ''
                if (page === 'recycle') {
                  if (action !== 'clear') {
                    detail = nowItem.name
                  }
                } else {
                  detail = '/' + nowItem.path
                }
                detail = detail.replace(/[/]{2,}/, '/')
                params.push({
                  account: this.userInStore.userName,
                  area: this.userInStore.area,
                  optType,
                  type,
                  detail
                })
              }
              if (value instanceof Array) {
                value.forEach((nowItem) => {
                  addRecords(nowItem)
                })
              } else {
                addRecords(value)
              }
          }
        }
      }
      let path = {}
      if (workspaceId) {
        path.workspaceId = workspaceId
      }
      if (projectId) {
        path.projectId = projectId
      }
      service.records[apiName](params, path).then((res) => {
        // console.log(res);
      })
    },
    // 获取 导出、下载、上传、复制、移动 进度
    getProgress (action, type, cacheKey, forSpace) {
      return new Promise(resolve => {
        let hit = false
        let requestTotal = 0
        window[action + 'ProgressTimerEmitter'] = setTimeout(() => {
          const ZJYTOKEN = getCookie('ZJYTOKEN')
          let title = '正在处理...'
          let optType = -1
          switch (action) {
            case 'upload':
              switch (+type) {
                case 0:
                  title = '正在上传数据...'
                  break
                default:
                  title = '正在上传文件...'
              }
              break
            case 'download':
              switch (+type) {
                case 0:
                  title = '正在下载云文件...'
                  break
                default:
                  title = '正在下载文件...'
              }
              break
            case 'move':
              optType = 1
              switch (+type) {
                case 0:
                  title = '正在移动...'
                  break
                default:
                  title = '正在移动文件...'
              }
              break
            case 'export':
              switch (+type) {
                case 0:
                  title = '正在导出数据...'
                  break
                default:
                  title = '正在导出文件...'
              }
              break
            case 'copy':
              optType = 0
              switch (+type) {
                case 0:
                  title = '正在复制到共享空间...'
                  break
                case 1:
                  title = '正在复制到电子档案室...'
                  break
                default:
                  title = '正在复制文件...'
              }
              break
            case 'import':
              title = '正在导入...'
              break
            default:
          }
          let params = {
            key: ZJYTOKEN + '_analysis_' + cacheKey
          }
          let apiName = 'getProgress'
          if (forSpace) {
            params.key = cacheKey
          } else if (optType > -1 && !(/^\d+$/.test(cacheKey))) {
            // 清单、定额、人材机、组价 复制到电子档案室和移动 获取进度条
            apiName = 'getCommonProgress'
            params.optType = optType
            params.modelType = cacheKey
            delete params.key
          }
          let percent = 0
          this.showProgress(title, percent)
          let requestRate = 1000
          const completeCb = () => {
            setTimeout(() => {
              resolve({
                hit: hit ? 2 : 1
              })
            }, 1000)
          }
          const getProgressFun = () => {
            if (requestRate > 5000) {
              requestRate = 1000
            }
            if (requestTotal > 100) {
              requestRate = 5000 // 如果轮询请求数大于100次了 则至少每隔5秒请求一次
            }
            const beforeRequest = new Date().getTime()
            MessageService[apiName](params).then(res => {
              if (+res.code === 200) {
                // is_end: "false"
                // percent: "19"
                if (apiName === 'getCommonProgress') {
                  // 清单、定额、人材机、组价 复制到电子档案室和移动 获取进度条
                  if (res.data) {
                    if (res.data.is_end === 'true') {
                      percent = 100
                      hit = true
                    } else if (res.data.percent) {
                      if (+res.data.percent > percent) {
                        percent = +res.data.percent
                      }
                      hit = true
                    }
                  }
                } else {
                  if (res.data) {
                    hit = true
                    if (+res.data >= percent) {
                      percent = +res.data
                    }
                  } else {
                    // 没命中缓存、且请求次数大于2次 直接显示100% 停止循环
                    if ((hit && percent < 100) || (!hit && requestTotal > 2)) {
                      percent = 100
                    }
                  }
                }
                this.showProgress(title, percent)
                if (percent === 100) {
                  completeCb()
                  if (action === 'upload') {
                    Bus.$emit('uploadOne')
                  }
                } else if (percent < 100 && percent >= 0) {
                  const afterRequest = new Date().getTime()
                  const requestTime = afterRequest - beforeRequest
                  // console.log(requestTime)
                  // console.log(baseTimeOut)
                  // console.log('-----------')
                  let timeOut = requestTime >= requestRate ? 0 : (requestRate - requestTotal)
                  window[action + 'ProgressTimer'] = setTimeout(() => {
                    requestTotal++
                    requestRate += 200
                    getProgressFun()
                  }, timeOut)
                }
              } else {
                this.$progress({closeAll: true})
                console.log(res.message)
                completeCb()
              }
            }).catch(error => {
              this.$progress({closeAll: true})
              console.log(error)
              completeCb()
            })
          }
          getProgressFun()
        }, 200)
      })
    },
    // 3.1 显示 进度条
    showProgress (title, percent, cb) {
      this.$progress({
        title,
        percent,
        close: (val) => {
          cb && cb(val)
        }
      })
    },
    // 4. 关闭所有弹窗
    hideAllDialog (cb) {
      const closeAll = true
      const task = [
        this.$confirm({closeAll}),
        this.$progress({closeAll})
      ]
      sessionStorage.removeItem('privacyShow')
      this.$store.commit('upload/CLOSE_UPLOAD_TASK_BOX') // 关闭 页面右下角 上传任务列表 盒子
      Promise.all(task).then(() => {
        cb && cb()
      })

    },
    // 5. 用户中心 单点退出
    accountLogout (adminAccount) {
      const zjyToken = getCookie('ZJYTOKEN')
      const zjyUserInfo = getCookie('ZJYUSERINFO')
      const rootPath = this.isCostCloud ? 'index' : 'login'
      if (!zjyToken || !zjyUserInfo) {
        this.logout()
        this.$router.push({
          path: `/${rootPath}`
        })
        deleteAllCookie()
        const iframePortal = document.getElementById('portalInnerIframe')
        iframePortal && iframePortal.remove()
        return
      }
      if (this.hasUploadTask && !confirm('该操作将会导致中断正在上传的任务，您是否确定?')) {
        // 有上传任务正在执行 且 确定弹窗 选择了取消
      } else {
        if (adminAccount) {
          sessionStorage.setItem('adminAccountInSession', adminAccount)
          setCookie('ADMIN_COUNT_HIT', adminAccount)
        }
        let hrefPrefix = this.hrefPrefix
        hrefPrefix = hrefPrefix.replace('-gray', '')
        hrefPrefix = hrefPrefix.replace('zjyrefactor', 'zjytest')
        hrefPrefix += `/#/${rootPath}?willLogin=true`
        // 清空user信息
        sessionStorage.removeItem('vuex')
        // 清空协同项目token
        sessionStorage.removeItem('gccsToken')
        sessionStorage.removeItem('wsId')
        // 退出前 关闭所有弹窗 结束上传任务
        this.hideAllDialog(() => {
          console.log('-account_logout--')
          sessionStorage.removeItem('privacyShow')
          this.checkSession()
          this.refreshHotpoint()
          service.user.accountLogout({domain: encodeURIComponent(hrefPrefix)}).then(res => {
            console.log(res)
            if (!res){
            // 单点登录 登出用户中心
              delCookie('ZJYUSERINFO')
              // delCookie("ZJYTOKEN")  // backend退出放在登录页了
              delCookie('ZJYSESSIONID')
              // session 删除 gldUserLogged 将会用作 灰度相关地址是否需要重定向到 非灰度的凭据
              delCookie('canVisitGray')
              const iframePortal = document.getElementById('portalInnerIframe')
              iframePortal && iframePortal.remove()
              this.logout()
              deleteAllCookie()
              this.$router.push({
                path: `/${rootPath}`
              })
            }
            if (+res.code === 200) {
              // console.log(JSON.stringify(res.data));
              // 单点登录 登出用户中心
              delCookie('ZJYUSERINFO')
              // delCookie("ZJYTOKEN")  // backend退出放在登录页了
              delCookie('ZJYSESSIONID')
              // session 删除 gldUserLogged 将会用作 灰度相关地址是否需要重定向到 非灰度的凭据
              delCookie('canVisitGray')
              this.logout()
              deleteAllCookie()
              window.location.href = res.data
            } else {
              this.$message.error(res.message || '账号系统登出失败.')
              // 单点登录 登出用户中心
              delCookie('ZJYUSERINFO')
              // delCookie("ZJYTOKEN")  // backend退出放在登录页了
              delCookie('ZJYSESSIONID')
              // session 删除 gldUserLogged 将会用作 灰度相关地址是否需要重定向到 非灰度的凭据
              delCookie('canVisitGray')
              this.logout()
              deleteAllCookie()
              const iframePortal = document.getElementById('portalInnerIframe')
              iframePortal && iframePortal.remove()
              this.$router.push({
                path: `/${rootPath}`
              })
            }
          })
        })
      }
    },
    // 5.1 用户中心 单点登录
    accountSingleLogin (redirectUrl) {
      // 单点登录用户中心redirectUrl参数不能是用户中心的地址
      LoginService.singleLogin({redirectUrl: window.location.href}).then(async (res) => {
        if (+res.code === 200 && res.data) {
          const url = res.data.match(/^.*&target_url=/)[0] + encodeURIComponent(`${accountUrl}${redirectUrl}`)
          window.open(url)
        } else {
          this.$message.error('用户中心单点登录失败，请稍后重试')
        }
      }).catch((e) => this.$message.error(e.message))
    },
    // 6. session 检查
    checkSession (init) {
      // const checkFn = () => {
      //   service.user.checkSession().then(data => {
      //     if (+data.code === 200 && previewShareGtj(this)) {
      //       // 处于登录状态 预览分享的 .gtj 文件
      //       // alert(previewShareGtj(this))
      //       // console.log(previewShareGtj(this))
      //       if (this.isIEBrowser()) {
      //         return
      //       } else {
      //         window.location.href = previewShareGtj(this)
      //       }
      //     }
      //     this.setUserInfo()
      //   })
      // }
      // clearInterval(this.sessionTimer)
      // this.sessionTimer = null
      // if (init) {
      //   checkFn()
      //   this.sessionTimer = setInterval(() => {
      //     checkFn()
      //   }, 1000 * 60 * 5)
      // }
    },
    // 7. 刷新小红点状态
    refreshHotpoint (refreshType) {
      if (this.isPreviewPage) {
        return
      }
      const types = ['Message', 'Upload', 'Feedback'] //  'Upload',
      // 发送请求
      const startFetch = type => {
        if (type === 'Upload') {
          // 获取历史上传 有无最新上传记录时 工程文件和 数据文件使用不同接口
          const task = [
            service.common.getHotpointUpload(), // 工程文件(空间上传文件)
            service.common.getHotpointUploadBigData() //  数据文件
          ]
          Promise.all(task).then((res) => {
            // console.log(res)
            if (res && res.length) {
              let messageStr = ''
              res.forEach((data, idx) => {
                if (+data.code === 200 && data.data) {
                  if (data.data !== '0') {
                    messageStr += data.data
                    if (idx < res.length - 1) {
                      messageStr += ','
                    }
                  }
                }
              })
              // console.log(messageStr)
              let menu = JSON.parse(JSON.stringify(this.uploadhistory))
              if (messageStr.indexOf('1') !== -1) {
                menu[2].children[0].point = true
              }
              if (messageStr.indexOf('2') !== -1) {
                menu[2].children[1].children[0].point = true
              }
              if (messageStr.indexOf('3') !== -1) {
                menu[2].children[1].children[1].point = true
              }
              this.setUploadData(menu)
              this.setUploadMessage(messageStr || '0')
              this.$forceUpdate()
            }
          })
        } else {
          service.common['getHotpoint' + type]().then(data => {
            if (+data.code === 200 && data.data !== undefined) {
              const path = this.$route.path
              switch (type) {
                // case 'Upload':
                //   let menu = JSON.parse(JSON.stringify(this.uploadhistory))
                //   if (data.data.indexOf(1) !== -1) {
                //     menu[2].children[0].point = true
                //   }
                //   if (data.data.indexOf(2) !== -1) {
                //     menu[2].children[1].children[0].point = true
                //   }
                //   if (data.data.indexOf(3) !== -1) {
                //     menu[2].children[1].children[1].point = true
                //   }
                //   this.setUploadData(menu)
                //   this.setUploadMessage(data.data || '0')
                //   this.$forceUpdate()
                //   break
                case 'Feedback':
                  if (!/^\/feedback\//.test(path)) {
                    this['new' + type] = data.data || false
                  }
                  break
                default:
                  this['new' + type] = data.data || false
              }
              this.refreshHeaderIndex++
            }
          })
        }
      }
      // 初始化计时器
      const initTimer = type => {
        this.timer[type] = setInterval(() => {
          startFetch(type)
        }, 1000 * 60 * 2)
      }
      types.forEach(type => {
        if (this.timer[type] && refreshType === 'init') {
          clearInterval(this.timer[type])
          this.timer[type] = null
        }
        if (refreshType) {
          switch (refreshType) {
            case 'init': // 首次进入系统  初始化 消息计时器
              startFetch(type)
              initTimer(type)
              break
            case 'afterUpload': // 上传完成后 刷新 更新 历史上传小红点
              if (type === 'Upload') {
                // startFetch(type)
              }
              break
            default:
          }
        }
      })
    },
    // 8. 是否为 IE 浏览器
    isIEBrowser () {
      if (isIE()) {
        this.$confirm({
          message: '当前浏览器不支持模型查看，请您使用Google浏览器查看模型。',
          type: 'downloadChrome',
          width: 400,
          showHeader: true,
          showClose: true,
          submit: () => {
            window.open('https://www.google.cn/chrome/')
            this.$router.push({path: '/index'})
          },
          cancel: () => {
            this.$router.push({path: '/index'})
          },
          submitText: '下载Google浏览器',
          noCancelBtn: true
        })
        return true
      }
      return false
    },
    // 9. 加载图片
    loadImg (src) {
      const img = new Image()
      img.src = src
      img.onload = function () {
        // console.log('==-----')
      }
    },
    // 10. 在新的标签页打开链接
    openLinkNewTab (obj, cb) {
      // appModule backend 单点登录后重定向地址 白名单校验依据（表） 1: 试用中心 2: 项目云应用 3: 菜单
      // appId 白名单在表中的id
      let {file = {}, linkUrl, zjySsoLogin = false, workspaceType, projectId, linkParameter = '', appModule = 3, appId = 1, windowName, openType = 1} = obj
      const { fileId, name, path, fileType, suffix } = file
      const fileName = name
      const filePath = path
      const fileTypeName = +fileType === 1 ? '计价' : (+fileType === 2 ? '计量' : '')
      const fileSuffix = suffix
      const role = +getCookie('role') || this.userInStore.role
      const personalWorkspaceIdValue = getCookie('personalWorkspaceIdValue')
      const enterpriseWorkspaceIdValue = getCookie('enterpriseWorkspaceIdValue')
      const projectWorkspaceIdValue = getCookie('projectWorkspaceIdValue')
      const routePath = this.$route.path
      let homeHref = window.location.href
      homeHref = homeHref.substring(0, homeHref.indexOf(routePath))
      homeHref += '/home'
      if (![1, 2, 3].includes(workspaceType)) {
        if (/^\/enterprise\/share/.test(routePath)) {
          workspaceType = 2 // 共享空间
        } else if (/^\/project\/(joined|all)/.test(routePath) || /^\/database\/data\/record/.test(routePath)) {
          workspaceType = 3 // 项目库
        } else {
          workspaceType = 1 // 个人/员工资料库
        }
      }
      let workspaceId = ''
      let viewToken = ''
      let viewId = ''
      let projectIOType = ''
      switch (workspaceType) {
        case 2:
          workspaceId = enterpriseWorkspaceIdValue
          projectIOType = '企业-共享'
          break
        case 3:
          workspaceId = projectWorkspaceIdValue
          projectIOType = '企业-项目'
          break
        default:
          workspaceId = personalWorkspaceIdValue
          projectIOType = '个人'
      }
      const { gldToken, gldUserId, token, area, userName } = this.userInStore
      const dic = {
        'ZJYTOKEN': getCookie('ZJYTOKEN') || token,
        'gldToken': getCookie('gldToken') || gldToken,
        'ZJYACCOUNT': getCookie('ZJYACCOUNT') || userName,
        'gldUserId': getCookie('gldUserId') || gldUserId,
        'LOGINREGION': getCookie('LOGINREGION') || area, // 地区
        role, // 角色
        // 'userType': (role > 1 && role < 5) ? 3 : (role === 5 ? 2 : 1), // 用户类型
        personalWorkspaceIdValue, // 个人空间ID
        enterpriseWorkspaceIdValue, // 共享空间ID
        projectWorkspaceIdValue, // 项目空间ID
        workspaceType, // 空间类型
        projectId, // 项目ID
        homeHref, // 造价云管理平台主页地址
        fileId, // 文件ID
        fileName, // 文件名称
        filePath, // 文件完整路径
        fileType, // 文件类型
        fileTypeName, // 文件类型名称
        fileSuffix, // 文件后缀
        workspaceId, // 空间ID
        viewToken, // 预览token
        viewId, // 预览ID
        projectIOType, // 空间名称【预览GTJ工程专用，不推荐使用】
        'DOGNUM': getCookie('DOGNUM') || ''
      }
      const linkParamArr = linkParameter.split(',')
      // 字典表数据设置完成，准备替换参数 然后重定向
      const dicReady = () => {
        let resultUrl = ''
        let linkUrlParam = ''
        if (linkUrl.indexOf('?') > -1) {
          resultUrl = linkUrl.substring(0, linkUrl.indexOf('?'))
          linkUrlParam = linkUrl.substring(linkUrl.indexOf('?'))
        } else {
          resultUrl = linkUrl
        }
        // 替换掉链接地址中(包含拼接在地址后的参数) 所有 ${参数名称} 格式的字符串为具体的值
        const replaceStr = (src, type) => {
          let resultSrc = src
          const reg = /\$\{([^}]+)\}/
          let matchedStr = reg.exec(resultSrc)
          while (matchedStr && matchedStr.length > 1) {
            let value = (type === 'link') ? 'undefined' : ''
            if (matchedStr[1] in dic) {
              value = encodeURIComponent(encodeURIComponent(dic[matchedStr[1]]))
            }
            resultSrc = resultSrc.replace(new RegExp('\\$\\{' + matchedStr[1] + '\\}'), value)
            matchedStr = reg.exec(resultSrc)
          }
          return resultSrc
        }
        resultUrl = replaceStr(resultUrl, 'link') // 路由地址中未知参数替换成 'undefined'
        linkUrlParam = replaceStr(linkUrlParam)// ?后面参数中未知参数替换成 ''
        console.log(resultUrl)
        console.log(linkUrlParam)
        let paramsObj = {}
        linkParamArr.forEach((key) => {
          if (key !== '') {
            paramsObj[key] = dic[key] || ''
          }
        })
        paramsObj = Object.assign(paramsObj, getParams(linkUrlParam))
        if ('hideLeftMenus' in paramsObj) {
          delete paramsObj['hideLeftMenus']
        }
        if (('zjySsoLogin' in paramsObj) || ('singleLogin' in paramsObj)) {
          zjySsoLogin = true
          delete paramsObj['zjySsoLogin']
          delete paramsObj['singleLogin']
        }
        if (JSON.stringify(paramsObj) !== '{}') {
          resultUrl = processParams(resultUrl, paramsObj)
        }
        if (zjySsoLogin) {
          // 需要走造价云管理平台的单点登录服务后 重定向过去
          resultUrl = service.common.zjySsoLogin() + '?weburl=' + encodeURIComponent(resultUrl) + '&appId=' + appId + '&appModule=' + appModule + '&token=' + dic['ZJYTOKEN']
          if (/^计价依据/.test(obj.name)) {
            // 试用中心/企业数据库 计价依据 的跳转需要拼接上 gldDogNum （没有共性的参数）
            resultUrl += '&gldDogNum=' + dic['DOGNUM']
          }
        }
        console.dir(resultUrl)
        if (cb && openType === 1) {
          cb(resultUrl)
        } else {
          window.open(resultUrl, windowName || '_blank')
        }
      }
      // 模型解析错误 停止重定向
      const modelError = () => {
        this.$confirm({
          type: 'imageAndText',
          imageSrc: this.bimFaceError,
          tips: '模型解析错误！',
          imageWidth: 140, // 图片宽度
          width: 360, // 弹窗宽度
          noCancelBtn: true
        })
      }
      if (/\$\{(viewToken|viewId)\}/.test(linkUrl) || linkParamArr.includes('viewToken') || linkParamArr.includes('viewId')) {
        // 需要获取viewToken、viewId
        const getViewToken = () => {
          const fileParams = {workspaceId}
          if (fileId !== '' && fileId !== undefined){
            fileParams.fileId = fileId
          } else {
            fileParams.filePath = filePath
          }
          // 备案
          if (/\/database\/data\/record\//.test(routePath)) {
            fileParams.projectId = window.recordedProjectId || projectId
          }
          service.space.getViewToken(fileParams).then((data) => {
            if (+data.code === 200 && data.data) {
              viewId = data.data.viewId
              viewToken = data.data.viewToken
              dic.viewId = viewId
              dic.viewToken = viewToken
              dicReady()
            } else {
              console.log('获取viewToken、viewId失败')
              modelError()
            }
          }).catch((e) => {
            console.log(e)
            dicReady()
          })
        }
        getViewToken()
      } else {
        // 不需要获取viewToken、viewId
        dicReady()
      }
    },
    // 进入文件所在目录
    directoryJump ({fileId, originStage, filePath, workspaceId, spaceType, path = ''}) {
      if (path) {
        return new Promise((resolve, reject) => {
          const errorMsg = '抱歉找不到您的文件，可能已被移动、重命名或删除'
          const params = {fileId, filePath, workspaceType: spaceType}
          if (workspaceId) {
            params.workspaceId = workspaceId
          }
          const loading = this.$loading({background: 'rgba(0, 0, 0, 0.3)', text: '文件信息获取中'})
          HomeService.getFileInfo(params).then(res => {
            loading.close()
            const {code, data} = res
            const {pageNum} = data || {}
            if (code === 200 && pageNum) {
              let query = {fileId, pageNum: data.pageNum, paths: filePath.substring(1)}
              // 项目空间
              if (originStage) {
                query.originStage = originStage
              }
              this.$router.push({path, query})
              resolve()
            } else {
              this.$message.error(errorMsg)
              reject(new Error(errorMsg))
            }
          }).catch((e) => {
            loading.close()
            reject(new Error(e.message))
          })
        })
      } else {
        Promise.reject(new Error('跳转路径不能为空'))
      }
    },
    // 4. 退出
    logout () {
      // 退出backend
      userService.logout().then(data => {
      })
      delCookie('ZJYUSERINFO')
      delCookie('ZJYTOKEN')
      delCookie('ZJYSESSIONID')
      this.setUserInfo({})
      this.user = {}
    }
  }
})
